import axiosInstance from "../axios_instance";

export async function createCategory(body) {
  try {
    return await axiosInstance.post(`categories/`, body);
  } catch (error) {
    return error;
  }
}

export async function updateCategory(body, id) {
  try {
    return await axiosInstance.put(`categories/${id}`, body);
  } catch (error) {
    return error;
  }
}

export async function getAllCategories(body) {
  try {
    return await axiosInstance.get(`categories/`, body);
  } catch (error) {
    return error;
  }
}

export async function deleteCategory(id) {
  try {
    const obj = { requestedAccess: 'Edit' }
    return await axiosInstance.delete(`categories/${id}`, obj);
  } catch (error) {
    return error;
  }
}
